import React from 'react';
import { Link } from 'react-router-dom';
import styles from './AboutHero.module.css';
import animation from '../../../Assets/About/animation1.gif';

const AboutHero = () => {
  return ( 
    <section className={styles.about_section}> 
      
      {/* ══ 1. DARK HERO BANNER ══ */}
      <div className={styles.page_hero}>
        <div className={styles.hero_inner}>
          {/* Breadcrumbs */}
          <nav className={styles.breadcrumb} aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span className={styles.breadcrumb_sep}>›</span>
            <span className={styles.breadcrumb_current}>About Us</span>
          </nav>
          
          <span className={styles.eyebrow}>Discover Our Story</span>
          <h1 className={styles.main_title}>
            Driving Digital Excellence as the <br />
            <span className={styles.highlight}>Best Marketing Company in Pune</span>
          </h1>
          <p className={styles.subtitle}>
            We blend data-driven strategy, creative brilliance, and cutting-edge technology to build brands that dominate their industry.
          </p>
        </div>
      </div>

      {/* ══ 2. WHO WE ARE (RICH CONTENT) ══ */}
      <div className={styles.about_main}>
        <div className={styles.about_main_content}>
            <div className={styles.image_container}>
              <img src={animation} alt='Best Marketing Company in Pune - Yeskondo Animation' className={styles.hero_image} />
            </div>

            <div className={styles.about_content_text}>
                <h2>Who We Are</h2>
                <p>
                  At <strong>Yeskondo Media Pvt. Ltd.</strong>, established in 2020, we don't just execute campaigns; we architect growth. Recognized as the top advertising agency in Pune, we pride ourselves on being a comprehensive, 360-degree media solutions provider. 
                </p>
                <p>
                  Our expertise spans across full-stack <strong>Digital Marketing, Technical SEO, Custom Web Development, and High-Impact OOH Advertising</strong>. We understand that in today's digital-first world, visibility is just the starting point. Conversion, retention, and brand loyalty are the true metrics of success.
                </p>
                <p>
                  Our dedicated team of creative thinkers and data analysts work in tandem to deliver innovative solutions tailored to your unique market positioning. Partner with the best marketing company in Pune to unlock your brand's full potential and secure a dominant position in the competitive landscape.
                </p>
                
                <div className={styles.content_bullets}>
                  <div className={styles.bullet_item}>
                    <span className={styles.check_icon}>✓</span>
                    <span>Data-Driven ROI Focused Strategies</span>
                  </div>
                  <div className={styles.bullet_item}>
                    <span className={styles.check_icon}>✓</span>
                    <span>Award-Winning Creative Campaigns</span>
                  </div>
                  <div className={styles.bullet_item}>
                    <span className={styles.check_icon}>✓</span>
                    <span>100% Transparent Reporting</span>
                  </div>
                </div>
            </div>
        </div>
      </div>

      {/* ══ 3. COMPANY STATS STRIP ══ */}
      <div className={styles.stats_strip}>
        <div className={styles.stats_inner}>
          <div className={styles.stat_box}>
            <h3 className={styles.stat_number}>5+</h3>
            <p className={styles.stat_label}>Years of Excellence</p>
          </div>
          <div className={styles.stat_box}>
            <h3 className={styles.stat_number}>250+</h3>
            <p className={styles.stat_label}>Projects Delivered</p>
          </div>
          <div className={styles.stat_box}>
            <h3 className={styles.stat_number}>150+</h3>
            <p className={styles.stat_label}>Happy Clients</p>
          </div>
          <div className={styles.stat_box}>
            <h3 className={styles.stat_number}>10x</h3>
            <p className={styles.stat_label}>Average ROI Growth</p>
          </div>
        </div>
      </div>

    </section>
  );
};

export default AboutHero;
